module.exports = __webpack_public_path__ + "media/components/assets/icons/eye_close-599adb7defad60226c0ecce4f7d9bfb1.svg";